// project modules
import interceptorsSetup from './axios';

export const init = () => {
  interceptorsSetup();
};
